import { EDUCATION_LEVEL_MAP } from '../constants';

export const getResponsibilityPermalink = (ouSearchDocument) => {
  // Ifs can be removed if Search Api is adapted to
  if (ouSearchDocument.type === 'KOEPEL') {
    return `/sam/organisationalunits/${ouSearchDocument.key}`;
  }
  if (ouSearchDocument.$$meta.permalink.match(/\/organisations\//)) {
    return `/kathondvla/organisationalunits/${ouSearchDocument.key}`;
  }
  return ouSearchDocument.$$meta.permalink;
};

export const getPositionDefinition = (position, ouType, mainstructures) => {
  return position.definitions.find(
    (definition) =>
      definition.applicableIn.ouTypes.some((type) => ouType === type) &&
      (!definition.applicableIn.mainstructures ||
        !mainstructures ||
        definition.applicableIn.mainstructures.some((defMs) => mainstructures.has(defMs)))
  );
};

export const getRequestDescription = (request) => {
  const ouName = request.organisationalUnit.$$expanded.$$displayName;
  return `${request.from.$$expanded.firstName} ${request.from.$$expanded.lastName}${
    request.position ? ` als ${request.position.$$expanded.name}` : ''
  } in ${ouName}`;
};
